<div class="modal" data-iframe-size>
  <div class="header">
    <button mat-icon-button class="close-button" [mat-dialog-close]="true">
      <mat-icon svgIcon="close"
              class="close-x"></mat-icon>
    </button>
  </div>
  <h3 class="title" translate>i18n.dialog.smartSorted.title</h3>
  <mat-dialog-content>
    <div class="content">
      <video [autoplay]="'autoplay'"
             [muted]="'muted'"
             controls
             playsinline
             loop>
        <source src="https://storage.googleapis.com/puzzleyou-misc/productdesigner/smart-sorted-small.mp4"
                type="video/mp4">
      </video>
    </div>
    <p translate>i18n.dialog.smartSorted.message</p>
  </mat-dialog-content>

  <dialog-buttons [buttons]="buttons"></dialog-buttons>
</div>
